module.exports = __webpack_public_path__ + "static/media/Amith Rajan.ed12fac0.jpg";